<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="isAddPopup ? '작업 추가' : '작업 수정'" width="600px" @close="close()">
    <div slot="content">
      <el-form :model="formData" :rules="rules" ref="jobForm">
        <el-row>
          <el-form-item prop="grpId" label="작업 그룹">
            <el-select v-model="formData.grpId" style="width: 100%" :disabled="formData.editableFlag === 'N'">
              <el-option v-for="grp in grpList" :key="grp.grpId" :label="grp.grpName" :value="grp.grpId"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="jobName" label="작업 이름">
            <el-input v-model="formData.jobName" placeholder="입력해주세요." :disabled="formData.editableFlag === 'N'"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item prop="failover" label="실패 제어">
            <el-select v-model="formData.failover" style="width: 100%" :disabled="formData.editableFlag === 'N'">
              <el-option v-for="key in ['CONTINUE', 'STOP']" :key="key" :label="key" :value="key"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" v-if="formData.editableFlag === 'Y'">
      <el-button size="large" type="solid" @click="onSaveButton">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil, isEqual, cloneDeep } from 'lodash';
import msgUtil from '@/utils/message';
import amsSettingsApi from '@/api/settings/server/ams-settings';

export default {
  name: 'WJobSettingPopup',
  props: {
    selectedJob: {
      type: Object,
      default: null,
    },
    selectedGroup: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      rules: {
        jobName: [
          { required: true, validator: this.validateJobName, trigger: 'blur' },
        ],
        grpId: [
          { required: true, validator: this.validateFieldInfo, trigger: 'blur' },
        ],
      },
      formData: {
        grpId: '',
        jobId: '',
        jobName: '',
        failover: '',
        editableFlag: 'Y',
      },
      grpList: [],
    };
  },
  computed: {
    isAddPopup() {
      return isNil(this.selectedJob);
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.loadGroupData();
      if (!this.isAddPopup) {
        this.formData = cloneDeep(this.selectedJob);
      } else {
        this.formData.failover = 'CONTINUE';
      }
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.$refs.jobForm.resetFields();
      this.formData = {
        grpId: '',
        jobId: '',
        jobName: '',
        failover: '',
        editableFlag: 'Y',
      };
    },
    loadGroupData() {
      amsSettingsApi.getAmsGrpList({ grpType: 'JOB' }).then((response) => {
        if (response.data.success) {
          this.grpList = response.data.data;
          if (this.isAddPopup && isNil(this.selectedGroup)) {
            this.formData.grpId = this.grpList.length > 0 ? this.grpList[0].grpId : '';
          } else if (!isNil(this.selectedGroup)) {
            this.formData.grpId = this.selectedGroup.grpId;
          }
        }
      });
    },
    validateJobName(rule, value, callback) {
      if (isNil(value) || value === '') {
        return callback(new Error('필수 정보입니다.'));
      }
      const isModified = this.isAddPopup || !isEqual(value, this.selectedJob.jobName);
      const params = { jobName: value };
      if (this.formData.jobId) {
        params.jobId = this.selectedJob.jobId;
      }
      amsSettingsApi.checkJobNameValidation(params).then((response) => {
        const isUniq = response.data.data;
        if (isModified && !isUniq) {
          callback(new Error('이미 사용 중인 작업 이름입니다.'));
        }
        callback();
      });
      return true;
    },
    validateFieldInfo(rule, value, callback) {
      if (isNil(value) || value === '') {
        callback(new Error('필수 정보입니다.'));
      } else {
        callback();
      }
    },
    onSaveButton() {
      this.$refs.jobForm.validate().then((valid) => {
        if (valid) {
          amsSettingsApi.insertJob(this.formData).then((response) => {
            const target = '작업';
            const action = this.isAddPopup ? msgUtil.action.ADD : msgUtil.action.MODIFY;
            if (response.data.success) {
              this.close();
              this.$emit('re-load');
            }
            this.$message(msgUtil.getResultMsgData(action, target, response.data.success));
          });
        }
      }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/JobSetting/popup/JobSettingPopup.vue